import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import HireFarmLabour from "../components/HireFarmLabour/HireFarmLabour";
import CommonFooter from "../components/CommonFooter/CommonFooter";

const FarmLabour = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <HireFarmLabour />
      <CommonFooter />
    </div>
  );
};

export default FarmLabour;
